export default __webpack_public_path__ + "images/models/0902dae3e775fd8a19fd755d1768b36b.usdz";